/**
 * Special purpose mutation to unset budget information back to the initialized state
 */
import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import AbEnvironment from '../auth/AbEnvironment';

const abEnvironment = new AbEnvironment();
    
const mutation = graphql`
  mutation RequestedBudgetAccountUnsetMutation($input: UpdateAccountTByAccountIdInput!) {
    updateAccountTByAccountId(input: $input) {
      accountT {
        accountId
        autoTopupActive
        initialBalanceAmount
        rAutoTopupAmount
        rAutoTopupThreshold
        rMaxCharge
        rMaxMonthlyBudget   
        useBudgets
        payFromBalance
      }
    }
  }
  `;

  function commit(accountId) {
    var variables = {
        input: {
            accountId,
            accountTPatch: {
              initialBalanceAmount: null,
              rAutoTopupActive: 0,
              rAutoTopupAmount: null,
              rAutoTopupThreshold: null,
              rMaxCharge: null,
              rMaxMonthlyBudget: null
            }
        }
    };

    return new Promise((resolve, reject) => {
      commitMutation(
        abEnvironment.getEnvironment(), {
          mutation,
          variables,
          onCompleted: (response) => {
            resolve(response);
          },
          onError: (error) => {
            reject(error);
          }
        }
      ); 
    });
  }
  /* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
  export default { commit };
  